import { render, staticRenderFns } from "./SuppliesRequestList.vue?vue&type=template&id=71e2fa18"
import script from "./SuppliesRequestList.vue?vue&type=script&lang=js"
export * from "./SuppliesRequestList.vue?vue&type=script&lang=js"
import style0 from "./SuppliesRequestList.vue?vue&type=style&index=0&id=71e2fa18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports